import { postRequest } from "../../config/axiosConfig";

export const createEmployeeSignup = async ({
  title,
  name,
  role,
  email,
  mobile,
  password,
  gender,
  dob,
  address,
  hospital_branch_id,
}) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/employee/signup",
      data: {
        title,
        name,
        role,
        email,
        mobile,
        password,
        gender,
        dob,
        address,
        hospital_branch_id,
      },
    });

    return response;
  } catch (error) {
    throw error;
  }
};

export const doEmployeeLogin = async ({ phone, password, latitude, longitude }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/employee/login",
      data: {
        mobile: phone,
        password,
        latitude,
        longitude
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Patient Login Successfull!",
      };
    } else {
      return {
        success: false,
        data: response,
      };
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid signup attempt for patient.",
    };
  }
};

export const doEmployeeLogout = async () => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "auth/employee/logout",
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Logged out Successfully!",
      };
    }
    return {
      success: false,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid logout attempt.",
    };
  }
};


export const employeeForgotPassword = async ({ forgotPhone }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "password/forgot-employee-password",
      data: {
        mobile: forgotPhone
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Otp send Successfully!",
      };
    }
    else {
      return {
        success: false,
        data: response,
      };
    }

  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid otp attempt",
    }

  }
}


export const employeeVerifyOtp = async ({ otp, phone }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "password/verify-employee-otp",
      data: {
        mobile: phone,
        otp: otp,
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Otp Verified",
      };
    }
    else {
      return {
        success: false,
        data: response,
      };
    }

  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid otp attempt",
    }

  }
}



export const employeeResetPassword = async ({ newPassword, confirmPassword, tempToken }) => {
  try {
    const response = await postRequest({
      url: process.env.REACT_APP_BASE_URL + "password/reset-employee-password",
      data: {
        new_password: newPassword,
        confirm_password: confirmPassword,
        tempToken: tempToken,
      },
    });

    if (response?.status === 200) {
      return {
        success: true,
        data: response,
        message: "Otp send Successfully!",
      };
    }
    else {
      return {
        success: false,
        data: response,
      };
    }

  } catch (error) {
    return {
      success: false,
      data: null,
      message: "Invalid otp attempt",
    }

  }
}